/* eslint-disable react/prop-types */
import React from 'react';
import { Link } from 'react-router-dom';
import numeral from 'numeral';
import moment from 'moment';
import { get } from 'lodash';

import { anticipationTracker } from '../../config/filters';
import { getRangeFromDays } from '../../utils/dates';

export const config = {
  ANTICIPATION_TRACKER_REPORT_PAGE_ID: 'anticipationTracker',
  ANTICIPATION_TRACKER_REPORT_FILTERS: anticipationTracker
};

export const columns = [
  {
    Header: 'Title',
    accessor: 'title',
    className: 'tvt-tabular-data-table__anticipation-tracker-title',
    Cell: ({ row: { original }, cell: { value } }) => (
      <Link
        to={`/${
          get(original, 'titleId', '').includes('-') ? 'movie' : 'show'
        }/${original.titleId}`}
      >
        {value}
      </Link>
    )
  },
  {
    Header: 'Release Date',
    accessor: 'releaseDate',
    className: 'tvt-tabular-data-table__anticipation-tracker-release_date',
    Cell: ({ row: { original }, cell: { value } }) =>
      moment(value).format('MM/DD/YYYY')
  },
  {
    Header: 'Growth Rate 40 Days Before Release',
    accessor: 'growth40',
    className:
      'tvt-tabular-data-table__anticipation-tracker-growth-40 caret-center',
    Cell: ({ row: { original }, cell: { value } }) =>
      numeral(value).format('0.00%')
  },
  {
    Header: 'Growth Rate First 7 Days',
    accessor: 'growth7',
    className:
      'tvt-tabular-data-table__anticipation-tracker-growth-7 caret-center',
    Cell: ({ row: { original }, cell: { value } }) =>
      numeral(value).format('0.00%')
  },
  {
    Header: 'Growth Rate Last 30 Days',
    accessor: 'growth30',
    className:
      'tvt-tabular-data-table__anticipation-tracker-growth-30 caret-center',
    Cell: ({ row: { original }, cell: { value } }) =>
      numeral(value).format('0.00%')
  },
  {
    Header: 'Total Followers',
    accessor: 'followers',
    className:
      'tvt-tabular-data-table__anticipation-tracker-followers caret-center',
    Cell: ({ row: { original }, cell: { value } }) => numeral(value).format(',')
  }
];

export const defaultSorts = ['followers'];

export const trackerFilters = {
  content: [
    {
      id: 'title',
      label: 'Title',
      tooltip:
        "Selecting multiple shows with ‘AND' will include viewers who watched ALL the shows selected (a smaller audience than a single show). \n Selecting multiple shows with ‘OR' will include viewers who watched ANY of the shows selected (a larger audience than a single show)."
    },
    {
      id: 'contentType',
      label: 'Content Type',
      tooltip: '',
      value: []
    },
    {
      id: 'network',
      label: 'Network',
      tooltip: ''
    },
    {
      id: 'studio',
      label: 'Studio',
      tooltip: ''
    },
    {
      id: 'genre',
      label: 'Genre',
      tooltip: ''
    },
    {
      id: 'first_release_date',
      label: 'Release Date',
      isToggle: true,
      options: [
        { value: null, label: 'All Time' },
        { value: getRangeFromDays(30).value, label: 'Last 30 days' },
        { value: getRangeFromDays(60).value, label: 'Last 60 days' },
        { value: getRangeFromDays(30, true).value, label: 'Next 30 days' },
        { value: getRangeFromDays(60, true).value, label: 'Next 60 days' },
        { value: -1, label: 'Custom', id: 'custom-date' }
      ]
    }
  ],
  demographic: [
    { id: 'age', label: 'Age Range' },
    { id: 'country', label: 'Region' },
    {
      id: 'gender',
      label: 'Gender',
      isToggle: true,
      options: [
        { value: null, label: 'All' },
        { value: 'female', label: 'Female' },
        { value: 'male', label: 'Male' }
      ]
    },
    {
      id: 'panel',
      label: 'Panel',
      isToggle: true,
      options: [
        { value: null, label: 'Total' },
        { value: 'Yes', label: 'Balanced' }
      ]
    }
  ]
};

export default { config, columns, defaultSorts };
